module.exports = __webpack_public_path__ + "img/screenshot-XD-perspective@2x.06212a1b.png";